// extracted by extract-css-chunks-webpack-plugin
module.exports = {"clockwise":"css-2ZmWYZCYk0","donut-rotate":"css-3CH_sRufwo"};